import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { cn } from '../../lib/utils';

export interface PhoneInputFieldProps {
  id?: string;
  value: string;
  onChange: (phone: string) => void;
  disabled?: boolean;
  placeholder?: string;
  hasError?: boolean;
  className?: string;
  /** Default country dial code. Defaults to 'in'. */
  defaultCountry?: string;
}

/**
 * PhoneInputField
 *
 * A common wrapper around `react-phone-input-2` that applies the project's
 * design-system CSS variables so it looks consistent across all pages.
 */
const PhoneInputField: React.FC<PhoneInputFieldProps> = ({
  id,
  value,
  onChange,
  disabled = false,
  placeholder = 'Enter phone number',
  hasError = false,
  className,
  defaultCountry = 'in',
}) => {
  return (
    <div id={id} className={cn('w-full', className)}>
      <PhoneInput
        country={defaultCountry}
        value={value}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        preferredCountries={['in', 'us', 'gb', 'ca', 'au']}
        enableSearch={true}
        inputStyle={{
          width: '100%',
          height: '36px',
          paddingLeft: '60px',
          border: `1px solid ${hasError ? 'hsl(var(--destructive))' : 'hsl(var(--border))'}`,
          borderRadius: '6px',
          backgroundColor: 'hsl(var(--background))',
          color: 'hsl(var(--foreground))',
          fontSize: '14px',
          boxSizing: 'border-box',
          outline: 'none',
        }}
        buttonStyle={{
          border: `1px solid ${hasError ? 'hsl(var(--destructive))' : 'hsl(var(--border))'}`,
          borderRadius: '6px 0 0 6px',
          backgroundColor: 'hsl(var(--background))',
          color: 'hsl(var(--foreground))',
        }}
        dropdownStyle={{
          backgroundColor: 'hsl(var(--background))',
          borderColor: 'hsl(var(--border))',
          color: 'hsl(var(--foreground))',
          zIndex: 9999,
        }}
        searchStyle={{
          backgroundColor: 'hsl(var(--background))',
          borderColor: 'hsl(var(--border))',
          color: 'hsl(var(--foreground))',
          width: '100%',
        }}
        inputClass="!bg-background !text-foreground"
        containerClass="w-full"
      />
    </div>
  );
};

export default PhoneInputField;
